export default __webpack_public_path__ + "static/media/coins.507462ac.gif";